import { Radio, LifeBuoy, Warehouse, Wrench, PackageSearch, GraduationCap, Search, BadgeCheck, Workflow, Truck } from "lucide-react";

export const LOGO = "/atlas-logo.png";
export const CAP_STATEMENT = "/Atlas_Contracting_Group_Capability_Statement.pdf";

export const CONTACT = {
  name: "Ian Miller",
  title: "Founder & Owner",
  phone: "619-622-4544",
  phoneHref: "tel:+16196224544",
  email: "ian.miller@atlascontractinggroup.com",
  website: "atlascontractinggroup.com",
  location: "Lancaster, Pennsylvania",
};

export const SAM_URL = "https://sam.gov";

export const COMPANY_DATA = [
  { label: "Legal Name", value: "Atlas Contracting Group LLC" },
  { label: "Business Type", value: "Veteran-Owned Small Business" },
  { label: "UEI", value: "HE6XT44NU883" },
  { label: "CAGE Code", value: "21G51" },
  { label: "SAM Status", value: "Active" },
  { label: "Service Area", value: "Federal Agencies & Prime Partners" },
];

export const NAICS = [
  { code: "423910", desc: "Sporting & Recreational Goods Merchant Wholesalers" },
  { code: "424350", desc: "Clothing & Clothing Accessories Merchant Wholesalers" },
  { code: "611430", desc: "Professional & Management Development Training" },
  { code: "541715", desc: "R&D in Physical, Engineering & Life Sciences" },
  { code: "541614", desc: "Process, Physical Distribution & Logistics Consulting" },
];

export const CAPABILITIES = [
  {
    id: "tactical-defense",
    icon: Radio,
    title: "Tactical & Defense Equipment",
    tag: "Our Specialty",
    desc: "Mission-ready tactical, communications, and protective equipment sourced precisely to your requirement.",
    examples: [
      "Tactical headsets and communications",
      "Hearing protection",
      "PPE and protective equipment",
      "Tactical clothing and gear",
      "Lighting, optics, cases, and accessories",
      "Range and training equipment",
    ],
    button: "Explore Tactical Solutions",
    href: "#tactical",
    img: "https://images.unsplash.com/photo-1579912436598-1156352c546c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHx0YWN0aWNhbCUyMGNvbW11bmljYXRpb25zJTIwaGVhZHNldCUyMG1pbGl0YXJ5JTIwb3BlcmF0b3J8ZW58MHx8fHwxNzg0ODI2NzI4fDA&ixlib=rb-4.1.0&q=85",
    featured: true,
  },
  {
    id: "safety-emergency",
    icon: LifeBuoy,
    title: "Safety & Emergency Equipment",
    desc: "Protective, medical, and emergency-response products that keep personnel safe and prepared.",
    examples: [
      "Personal protective equipment",
      "Emergency-response supplies",
      "Medical and first-aid equipment",
      "Fire and workplace safety products",
      "Disaster-preparedness supplies",
      "High-visibility clothing and equipment",
    ],
    button: "Explore Safety Solutions",
    href: "#contact",
    img: "https://images.pexels.com/photos/34136290/pexels-photo-34136290.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    id: "facility-operational",
    icon: Warehouse,
    title: "Facility & Operational Supplies",
    desc: "Tools, maintenance, storage, and facility products that keep government operations running.",
    examples: [
      "Tools and industrial equipment",
      "Maintenance and janitorial supplies",
      "Storage and material-handling products",
      "Office and facility furniture",
      "Building and electrical supplies",
      "Fleet and vehicle accessories",
    ],
    button: "Explore Operational Supplies",
    href: "#contact",
    img: "https://images.unsplash.com/photo-1689942010216-dc412bb1e7a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwd2FyZWhvdXNlJTIwc2hlbHZpbmclMjBzdXBwbGllc3xlbnwwfHx8fDE3ODQ4MjY3Mjh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "facility-services",
    icon: Wrench,
    title: "Facility Services",
    desc: "Partner-supported facility services that keep government buildings, grounds, and operations mission-ready.",
    examples: [
      "Janitorial and custodial services",
      "Grounds maintenance and landscaping",
      "Facility maintenance and minor repair support",
      "Waste management and disposal coordination",
      "Warehousing and material-handling support",
      "Relocation, setup, and installation support",
    ],
    button: "Request Facility Services",
    href: "#contact",
    img: "https://images.unsplash.com/photo-1580256081112-e49377338b7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1080",
  },
  {
    id: "training-technical-services",
    icon: GraduationCap,
    title: "Training & Technical Services",
    desc: "Beyond products, Atlas delivers partner-supported training and technical services that keep equipment mission-ready.",
    examples: [
      "Equipment familiarization and use training",
      "Safety and operational instruction",
      "Requirements research and market analysis",
      "Product evaluation and testing coordination",
      "Prototype and development-partner sourcing",
      "Documentation and post-delivery support",
    ],
    button: "Request Services Support",
    href: "#contact",
    img: "https://images.unsplash.com/photo-1668724982255-1a3e0c72b814?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzh8MHwxfHNlYXJjaHwzfHxtaWxpdGFyeSUyMHRhY3RpY2FsJTIwdHJhaW5pbmclMjBvcGVyYXRpb258ZW58MHx8fHwxNzgyMzAzMTQ5fDA&ixlib=rb-4.1.0&q=85",
  },
  {
    id: "procurement-support",
    icon: PackageSearch,
    title: "Procurement & Contract Support",
    desc: "When a requirement doesn't fit a category, we source, coordinate, and deliver the right solution.",
    examples: [
      "Specialized product sourcing",
      "Manufacturer and distributor coordination",
      "Supplier quote management",
      "Order fulfillment and delivery",
      "Subcontractor coordination",
      "Product research and market analysis",
    ],
    button: "Request Procurement Support",
    href: "#contact",
    img: "https://images.pexels.com/photos/4480985/pexels-photo-4480985.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
];

export const CAP_MENU = CAPABILITIES.map((c) => ({ id: c.id, title: c.title }));

export const TACTICAL_ITEMS = [
  "Tactical headsets & communications",
  "Hearing protection",
  "PPE & protective equipment",
  "Tactical clothing & gear",
  "Lighting, optics & cases",
  "Range & training equipment",
];

export const PROCESS = [
  { num: "01", icon: Search, title: "Source", desc: "We identify qualified manufacturers and distributors and match products to your exact requirement, spec, and budget." },
  { num: "02", icon: BadgeCheck, title: "Verify", desc: "We confirm compatibility, compliance, lead time, and best value before anything is quoted." },
  { num: "03", icon: Workflow, title: "Coordinate", desc: "We manage suppliers, documentation, schedule, and communication as your single point of contact." },
  { num: "04", icon: Truck, title: "Deliver", desc: "We track fulfillment through delivery — CONUS and approved OCONUS — with complete documentation." },
];

export const FAQS = [
  {
    q: "How can a federal agency purchase from Atlas?",
    a: "We support multiple procurement paths — Government Purchase Card (GPC), purchase orders (SF-1449), micro-purchases, simplified acquisitions, and BPAs. Send us your requirement or solicitation and we'll respond with a compliant quote.",
  },
  {
    q: "Are you registered and active in SAM.gov?",
    a: "Yes. Atlas Contracting Group LLC is active in SAM.gov with UEI HE6XT44NU883 and CAGE Code 21G51. You can verify our registration on SAM.gov using the button in the Company Credentials section.",
  },
  {
    q: "What socioeconomic status do you hold?",
    a: "Atlas is a Veteran-Owned Small Business. We're built to team with prime contractors, OEMs, and distributors, and to support small-business and set-aside goals on your contract.",
  },
  {
    q: "Which NAICS codes do you sell under?",
    a: "Our target NAICS codes are 423910, 424350, 611430, 541715, and 541614 — covering tactical equipment and apparel, training, R&D, and logistics consulting.",
  },
  {
    q: "Do you respond to solicitations and RFQs?",
    a: "Absolutely. Submit your RFQ/RFP number and attach the spec sheet or solicitation document through our contact form and we'll review and respond promptly. You can also email us directly.",
  },
  {
    q: "Can you handle CONUS and OCONUS delivery?",
    a: "Through our supplier and logistics partners, we coordinate delivery, documentation, and tracking for both CONUS and approved OCONUS destinations based on the requirement.",
  },
];

export const HERO_BG =
  "https://images.unsplash.com/photo-1759167625071-069dc252702f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwxfHx0YWN0aWNhbCUyMGVxdWlwbWVudCUyMGRhcmt8ZW58MHx8fHwxNzgyMzAzMDc4fDA&ixlib=rb-4.1.0&q=85";

export const TACTICAL_BG =
  "https://images.unsplash.com/photo-1765513265796-3c21b92cb516?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwzfHx0YWN0aWNhbCUyMG1pbGl0YXJ5JTIwZ2VhciUyMGVxdWlwbWVudCUyMGRhcmt8ZW58MHx8fHwxNzgyMzAzMTQ5fDA&ixlib=rb-4.1.0&q=85";
